import { render, staticRenderFns } from "./PatientReportSection.vue?vue&type=template&id=8bad0824&scoped=true"
import script from "./PatientReportSection.vue?vue&type=script&lang=js"
export * from "./PatientReportSection.vue?vue&type=script&lang=js"
import style0 from "./list.css?vue&type=style&index=0&id=8bad0824&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bad0824",
  null
  
)

export default component.exports